<h1>{{data.title}}</h1>
<p>{{data.message}}</p>


<div style="display: flex; justify-content: end; gap: 10px">
    <button mat-flat-button (click)="dialogRef.close(true)" color="primary">
        <mat-icon>cancel</mat-icon>
        Ok
    </button>
    <button mat-flat-button (click)="dialogRef.close()">
        <mat-icon>cancel</mat-icon>
        Cancel
    </button>
</div>
